<script setup>
import EyeIcon from '@iconify-vue/ph/eye';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import { formatDate } from '@js/utils/formatter';
import { useRoute } from '@js/utils/route';

const props = defineProps({
    appointment: {
        type: Object,
        required: false,
        default: null,
    },
});

const { route } = useRoute();
</script>

<template>
    <div class="relative inline-flex h-full items-center justify-start p-4">
        <div class="flex h-full flex-col gap-2">
            <div class="font-bold">
                {{ props.appointment.subject }}
            </div>

            <div class="flex h-full items-center gap-4">
                <div class="flex flex-col items-start gap-2">
                    <div class="flex items-center gap-2">
                        <div
                            class="flex items-center gap-1 text-sm font-medium"
                        >
                            {{ formatDate(props.appointment.scheduledAt) }}
                        </div>

                        <ActionButton
                            size="small"
                            type="secondary"
                            title="Voir"
                            :icon="EyeIcon"
                            square
                            :href="
                                route(
                                    'front.projectManagement.apikom.updateAppointment',
                                    {
                                        tenantAppointment: props.appointment.id,
                                    },
                                )
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
